import type StaticMapSize from '@alltrails/types/StaticMapSize';

export type Size = StaticMapSize | '1280x480' | '295x240';

type Args = {
  apiKey: string;
  baseUrl: string;
  id: string | number;
  includePois?: boolean;
  locale?: string;
  scale: number;
  size: Size;
  style?: 'alltrails' | 'satellite';
  type: 'trails' | 'maps';
};

const getStaticMapUrl = ({ apiKey, baseUrl, id, includePois, locale, scale, size, style, type }: Args) => {
  const params = new URLSearchParams();
  params.set('key', apiKey);
  params.set('size', size);
  params.set('scale', String(scale));

  if (style) {
    params.set('style', style);
  }

  if (includePois) {
    params.set('pois', 'true');
  }

  return [baseUrl, locale, `api/alltrails/v3/${type}/${id}/static_map?${params.toString()}`].filter(Boolean).join('/');
};

export default getStaticMapUrl;
